import React, { useContext } from "react";

import {
  Divider,
  Grid,
  Button
} from "@material-ui/core";
import DirectionsIcon from "@material-ui/icons/Directions";

import { PageContext } from "../../contexts/PageContext";
import { getMonthsBetween } from "../../functions/GlobalHelpers"


export default function CreditFieldGroupVorlastKonsum(
  {
    renderCreditField,
    creditFunctions,
    index
  }) {

  const pageContext = useContext(PageContext);

  return (
    <>
      {renderCreditField("__vorlast" + index + "__kreditnehmer", 6, 4)}
      {renderCreditField("__vorlast" + index + "__institut", 6, 4)}
      {renderCreditField("__vorlast" + index + "__iban", 6, 4, "iban")}
      {/* {renderCreditField("__vorlast" + index + "__betrieblicher_kredit", 12, 4)} */}
      {renderCreditField("__vorlast" + index + "__zukunft", 12, 4)}
      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__vorlast" + index + "__urspr_kreditbetrag", 6, 4, "euro")}
      {renderCreditField("__vorlast" + index + "__monatliche_rate", 6, 4, "euro")}
      {renderCreditField("__vorlast" + index + "__aktuelle_aushaftung", 6, 4, "euro")}
      {renderCreditField("__vorlast" + index + "__umschuldung_erwuenscht", 12, 4)}
      {renderCreditField("__vorlast" + index + "__abloesung_durch_eigenkapital", 12, 4)}
      {renderCreditField("__vorlast" + index + "__leasingrate_nachgewiesen", 12, 4)}
      {/* {renderCreditField("__vorlast" + index + "__kreditnehmer_bedient_rate_nicht", 12, 6)} */}
    </>
  );
}
